export interface IPagination {
  current_page :number;
  from :number | null;
  last_page :number;
  path ?:string;
  per_page :number;
  to :number | null;
  total :number;
  pageIndex ?:number | null;
}

export interface IPaginatorEvent {
  length :number;
  pageIndex :number;
  pageSize :number;
  previousPageIndex :number;
}

export interface IPaginatedGetResponse {
  current_page :number;
  data :any[];
  path :string;
  first_page_url :string;
  next_page_url :string | null;
  last_page_url :string | null;
  prev_page_url :string | null;
  from :number | null;
  to :number | null;
  per_page :number;
  last_page :number;
  total :number;
}

export interface IPaginationResponse {
  data :any[];
  links :any;
  meta :any;
}

export const DEFAULT_PAGINATION :IPagination = {
  current_page: 1,
  from: null,
  last_page: 1,
  per_page: 100,
  to: null,
  total: 0,
  pageIndex: null,
};
